import React from 'react';
import { FaTrashAlt, FaPenSquare } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import useCashFlows from '../hooks/useCashFlows';
import {
  TableWrapper,
  Table,
  TableHeader,
  TableRow,
  TableData,
  EditButton,
  DeleteButton,
} from '../styles/ComponentStyles';
import PaginationControl from './PaginationControl';

const CashFlowsTable = ({
  refreshKey,
  setRefreshKey,
  handleFlashMessage,
  handleDelete,
  currentPage,
  currentPageLimit,
  onPageChange,
  onPageLimitChange,
}) => {
  const navigate = useNavigate();
  const { cash_flows, totalPages, loading, error } = useCashFlows(currentPage, currentPageLimit, refreshKey);

  const handleEdit = (cash_flowId) => navigate(`/edit-cash_flow/${cash_flowId}`);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading cash_flows.</div>;

  return (
    <TableWrapper>
      <h2>Cash Flows List</h2>
      <Table>
        <thead>
          <tr>
            <TableHeader>Date of Transaction</TableHeader>
            <TableHeader>Cash Flow Name</TableHeader>
            <TableHeader>Cash Flow Type</TableHeader>
            <TableHeader>Amount</TableHeader>
            <TableHeader>Maintaining Balance</TableHeader>
            <TableHeader>Status</TableHeader>
            <TableHeader>Platform</TableHeader>
            <TableHeader>Remarks</TableHeader>
            <TableHeader>Actions</TableHeader>
          </tr>
        </thead>
        <tbody>
          {cash_flows.map((cash_flow) => {
            const amount = parseFloat(cash_flow.amount) || 0;
            const threshold = parseFloat(cash_flow.maintaining_balance) || 0;
            const isBelowThreshold = threshold > 0 && amount < threshold;

            return (
              <TableRow key={cash_flow._id}>
                <TableData>{cash_flow.date_of_transaction}</TableData>
                <TableData>{cash_flow.cash_flow_name}</TableData>
                <TableData>{cash_flow.cash_flow_type}</TableData>
                <TableData>{cash_flow.amount}</TableData>
                <TableData>{cash_flow.maintaining_balance || '-'}</TableData>
                <TableData>
                  {threshold > 0 ? (
                    <span style={{
                      backgroundColor: isBelowThreshold ? '#FF9800' : '#4CAF50',
                      color: 'white',
                      padding: '2px 8px',
                      borderRadius: '4px',
                      fontSize: '0.75rem',
                      fontWeight: 'bold'
                    }}>
                      {isBelowThreshold ? '⚠️ Below' : '✓ Above'}
                    </span>
                  ) : '-'}
                </TableData>
                <TableData>{cash_flow.platform}</TableData>
                <TableData>{cash_flow.remarks}</TableData>
                <TableData>
                  <EditButton onClick={() => handleEdit(cash_flow._id)}>
                    <FaPenSquare />
                  </EditButton>
                  <DeleteButton onClick={() => handleDelete(cash_flow._id)}>
                    <FaTrashAlt />
                  </DeleteButton>
                </TableData>
              </TableRow>
            );
          })}
        </tbody>
      </Table>
      <PaginationControl
        currentPage={currentPage}
        totalPages={totalPages}
        handlePageChange={onPageChange}
        currentPageLimit={currentPageLimit}
        handlePageLimitChange={onPageLimitChange}
      />
    </TableWrapper>
  );
};

export default CashFlowsTable;
